export default {
    common: {
        title: 'Redigera bild',
        cancel: 'Avboka',
        save: 'Spara',
        crop: 'Gröda',
        adjustments: 'Justeringar',
        filters: 'Filter',
        frames: 'Ramar',
        overlays: 'Överlagringar',
        text: 'Text',
        stickers: 'klistermärken',
        brush: 'Borste',
        ai: 'Skapa bild med AI',
        reset: 'Återställa',
        comingSoon: 'Inom kort...',
        apply: 'Ansök',
        undo: 'Ångra',
        redo: 'klar',
        flipHorizontal: 'Spegelvänd horisontellt',
        flipVertical: 'Vänd Vertikalt',
        rotateClockwise: 'Rotera medurs',
        rotateAntiClockwise: 'Rotera moturs',
        warning: 'Varning',
        discard: 'Kasta bort',
        continue: 'Fortsätt redigera',
        discardHeading: 'Släng bort dina ändringar?',
        discardSubHeading: 'Om du stänger bildredigeraren så kommer inte dina ändringar att sparas',
        subtitle: 'De stödda bildformaten är PNG och JPEG',
        clone: 'Klon',
        delete: 'Radera',
    },
};
